import CustomCheckbox from "../CustomCheckbox";
import { showGrade } from "../../utils/textUtils";

const sectionTitle = {
  fontSize: "0.78rem",
  fontWeight: 800,
  letterSpacing: "0.06em",
  color: "#00A396",
  margin: "0 0 10px",
};

const rowStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginBottom: "7px",
};

const labelStyle = { fontSize: "0.88rem", fontWeight: 600, color: "#3A434E" };

const FilterPanel = ({
  gradeOptions,
  levelOptions,
  gradeList,
  levelList,
  setGradeList,
  setLevelList,
}) => {
  const toggleGrade = (grade) => {
    setGradeList((prev) => {
      return prev.includes(grade)
        ? prev.filter((g) => g !== grade)
        : [...prev, grade];
    });
  };

  const toggleLevel = (level) => {
    setLevelList((prev) => {
      return prev.some((l) => l.id === level.id)
        ? prev.filter((l) => l.id !== level.id)
        : [...prev, level];
    });
  };

  // 학년 전체 선택/해제
  const handleGradeSelectAll = (isSelected) => {
    setGradeList(isSelected ? [...gradeOptions] : []);
  };

  // 클래스 전체 선택/해제
  const handleLevelSelectAll = (isSelected) => {
    setLevelList(isSelected ? [...levelOptions] : []);
  };

  return (
    <div
      style={{
        borderRight: "1px solid #E6EDEC",
        color: "#0E141B",
        padding: "12px 14px",
      }}
    >
      {/* Grade 리스트 */}
      <div>
        <h3 style={sectionTitle}>학년</h3>
        <div style={{ ...rowStyle, paddingBottom: "4px", borderBottom: "1px solid #E6EDEC", marginBottom: "9px" }}>
          <CustomCheckbox
            checked={gradeList.length === gradeOptions.length}
            indeterminate={
              gradeList.length > 0 && gradeList.length < gradeOptions.length
            }
            onChange={(e) => handleGradeSelectAll(e.target.checked)}
          />
          <span style={{ ...labelStyle, fontWeight: 700 }}>전체 선택</span>
        </div>
        {gradeOptions.map((grade) => (
          <div key={grade} style={rowStyle}>
            <CustomCheckbox
              checked={gradeList.includes(grade)}
              onChange={() => toggleGrade(grade)}
            />
            <span style={labelStyle}>{showGrade(grade)}</span>
          </div>
        ))}
      </div>

      {/* Level 리스트 */}
      <div style={{ marginTop: "22px" }}>
        <h3 style={sectionTitle}>클래스</h3>
        <div style={{ ...rowStyle, paddingBottom: "4px", borderBottom: "1px solid #E6EDEC", marginBottom: "9px" }}>
          <CustomCheckbox
            checked={levelList.length === levelOptions.length}
            indeterminate={
              levelList.length > 0 && levelList.length < levelOptions.length
            }
            onChange={(e) => handleLevelSelectAll(e.target.checked)}
          />
          <span style={{ ...labelStyle, fontWeight: 700 }}>전체 선택</span>
        </div>
        {levelOptions.map((level) => (
          <div key={level.id} style={rowStyle}>
            <CustomCheckbox
              checked={levelList.some((l) => l.id === level.id)}
              onChange={() => toggleLevel(level)}
            />
            <span style={labelStyle}>{level.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterPanel;
